import type { KaplayCtx } from "../kaplayCtx";

interface AnimDef {
  from: number;
  to: number;
  loop?: boolean;
  speed?: number;
}

interface SpriteOptions {
  sliceX?: number;
  sliceY?: number;
  anims?: Record<string, AnimDef>;
}

interface SpriteConfig {
  name: string;
  path: string;
  options?: SpriteOptions;
}

interface AssetConfig {
  name: string;
  path: string;
}

const sprites: SpriteConfig[] = [
  { name: "intro-bg", path: "graphics/intro-bg.png" },
  { name: "tree", path: "graphics/tree.png" },
  { name: "cabinet", path: "graphics/cabinet.png" },
  { name: "arcade", path: "graphics/arcade.png" },
  { name: "register-desk", path: "graphics/register-desk.png" },
  { name: "education-desk", path: "graphics/education-desk.png" },
  { name: "repair-station", path: "graphics/repair-station.png" },
  {
    name: "repair-worker",
    path: "graphics/repair-worker.png",
    options: {
      sliceX: 6,
      sliceY: 2,
      anims: {
        welding: { from: 0, to: 3, loop: true, speed: 6 },
        dancing: { from: 6, to: 11, loop: true, speed: 8 },
      },
    },
  },
  {
    name: "husky",
    path: "graphics/husky.png",
    options: {
      sliceX: 8,
      sliceY: 4,
      anims: {
        "idle-right": { from: 0, to: 7, loop: true, speed: 5 },
        "idle-left": { from: 8, to: 15, loop: true, speed: 5 },
        "walk-right": { from: 16, to: 23, loop: true, speed: 10 },
        "walk-left": { from: 24, to: 31, loop: true, speed: 10 },
        "pet-right": { from: 0, to: 7, loop: true, speed: 14 },
        "pet-left": { from: 8, to: 15, loop: true, speed: 14 },
      },
    },
  },
  {
    name: "sales-woman",
    path: "graphics/sales-woman.png",
    options: {
      sliceX: 4,
      sliceY: 2,
      anims: {
        idle: { from: 0, to: 3, loop: true, speed: 4 },
        dancing: { from: 4, to: 7, loop: true, speed: 8 },
      },
    },
  },
  {
    name: "register-person",
    path: "graphics/register-person.png",
    options: {
      sliceX: 4,
      sliceY: 3,
      anims: {
        "writing-right": { from: 0, to: 3, loop: true, speed: 4 },
        "writing-left": { from: 4, to: 7, loop: true, speed: 4 },
        dancing: { from: 8, to: 11, loop: true, speed: 8 },
      },
    },
  },
  {
    name: "education-worker",
    path: "graphics/education-worker.png",
    options: {
      sliceX: 6,
      sliceY: 2,
      anims: {
        typing: { from: 0, to: 3, loop: true, speed: 4 },
        dancing: { from: 6, to: 11, loop: true, speed: 8 },
      },
    },
  },
  {
    name: "rider",
    path: "graphics/rider-new.png",
    options: {
      sliceX: 8,
      sliceY: 2,
      anims: {
        "walk-right": { from: 0, to: 7, loop: true, speed: 10 },
        "walk-left": { from: 8, to: 15, loop: true, speed: 10 },
      },
    },
  },
];

const fonts: AssetConfig[] = [{ name: "mania", path: "fonts/mania.ttf" }];

export function loadAllAssets(k: KaplayCtx): void {
  for (const { name, path, options } of sprites) {
    k.loadSprite(name, path, options);
  }
  for (const { name, path } of fonts) {
    k.loadFont(name, path);
  }
}
